import { render, staticRenderFns } from "./EditorDataStatus.vue?vue&type=template&id=47eeb9b6&scoped=true&"
import script from "./EditorDataStatus.vue?vue&type=script&lang=js&"
export * from "./EditorDataStatus.vue?vue&type=script&lang=js&"
import style0 from "./EditorDataStatus.vue?vue&type=style&index=0&id=47eeb9b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47eeb9b6",
  null
  
)

export default component.exports